export default __webpack_public_path__ + "static/media/0001.1340ac96.WAV";